export default __webpack_public_path__ + "static/power_engine-0fc98f5fa6f5484ffdec7cfe2ee944ff.webp";